import React from 'react';
import { } from '@mui/material';
import "./styles.css"

import CancelIcon from '@mui/icons-material/Cancel';

const PageCountSelect = (props) => {
    return (
        <div id="page-count-select">
            <select onChange={(e) => {
                props.onChange(Number(e.target.value));
            }}>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
            </select>
        </div>
    );
};

export default PageCountSelect;